import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LanguageManagementService } from '../../../service/language-management.service';
import { KeyValues10, KeyValueSetInt, LocalService, WorkingRangeType } from '../../../service/local.service';

@Component({
  selector: 'app-working-hours-range',
  templateUrl: './working-hours-range.component.html',
  styleUrls: ['./working-hours-range.component.scss']
})
export class WorkingHoursRangeComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["working_hours"]; config = null;
  @Input() workingRangeType: WorkingRangeType = WorkingRangeType.None; isAnyTime: boolean = false;
  @Input() isOnlyTime = false; weekDays: KeyValueSetInt[] = []; isShowWeekDays = true; header = '';
  @Input() selectedRange: KeyValues10; isShowToRange: boolean = true; @Input() isReadOnly = false; @Input() isHeaderRequired = true;
  @Output() onRangeUpdated = new EventEmitter(); @Input() IsNeedNewLine = true; @Input() IsMandatory = false;

  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    if (!this.isAnyTime)
      this.isAnyTime = this.selectedRange && this.selectedRange.v1 == '1';
    if (!this.selectedRange || !this.selectedRange.key || this.selectedRange.key == '') {
      this.selectedRange = { key: '', v1: (this.isAnyTime ? '1' : '0'), v2: '', v3: this.onGetTime(false), v4: '', v5: this.onGetTime(true), v6: '', v7: this.workingRangeType.toString() } as KeyValues10;
    }
    this.onLoad();
  }

  onLoad() {
    this.onSetDateConfig();
    if (this.selectedRange.v2 == '')
      this.selectedRange.v2 = this.localService.getTodayDateForCalender();
    if (this.selectedRange.v4 == '')
      this.selectedRange.v4 = this.selectedRange.v2;
    this.onRangeUpdated.emit(this.selectedRange);

    switch (this.workingRangeType) {
      case WorkingRangeType.Deliverer: {
        this.isOnlyTime = true;
      } break;
      case WorkingRangeType.PickUp:
      case WorkingRangeType.Appoinment: {
        this.isShowWeekDays = false;
        this.isShowToRange = false;
      } break;
    }
    this.getWeekDays();
  }

  onGetTime(isTo: boolean) {
    let date = this.localService.getDeviceDate();
    let hrs = date.getHours() + (isTo ? 2 : 1);
    hrs = hrs >= 24 ? 24 : hrs;
    let mins = date.getMinutes();
    mins = mins >= 30 ? 30 : 0;
    let amPm = hrs >= 12 ? 'pm' : 'am';
    hrs = hrs >= 12 ? hrs - 12 : hrs;
    let time = (hrs > 9 ? '' : '0') + hrs + ':' + (mins > 9 ? '' : '0') + mins + ' ' + amPm;
    let crossedTime = ['12:00 pm', '12:30 pm'];
    if (crossedTime.indexOf(time) > -1)
      time = '11:59 pm';
    return time;
  }

  onSetDateConfig() {
    let today = this.localService.getDeviceDate();
    let date = today.getDate();
    let month = today.getMonth() + 1;
    let minDt = (date.toString().length == 1 ? ('0' + date) : date) + '-' + (month.toString().length == 1 ? ('0' + month) : month) + '-' + today.getFullYear();
    this.config = { min: minDt, firstDayOfWeek: 'mo', showWeekNumbers: true, numOfMonthRows: 4 };
  }

  getWeekDays() {
    setTimeout(() => {
      if (this.localService.languageContent.working_hours) {
        let selectedDays = [];
        if (this.selectedRange.v6)
          selectedDays = this.selectedRange.v6.split(',');
        this.weekDays = [
          { key: 1, value: this.localService.languageContent.working_hours.monday, isSelected: selectedDays.indexOf('1') > -1 } as KeyValueSetInt
          , { key: 2, value: this.localService.languageContent.working_hours.tuesday, isSelected: selectedDays.indexOf('2') > -1 } as KeyValueSetInt
          , { key: 3, value: this.localService.languageContent.working_hours.wednesday, isSelected: selectedDays.indexOf('3') > -1 } as KeyValueSetInt
          , { key: 4, value: this.localService.languageContent.working_hours.thursday, isSelected: selectedDays.indexOf('4') > -1 } as KeyValueSetInt
          , { key: 5, value: this.localService.languageContent.working_hours.friday, isSelected: selectedDays.indexOf('5') > -1 } as KeyValueSetInt
          , { key: 6, value: this.localService.languageContent.working_hours.saturday, isSelected: selectedDays.indexOf('6') > -1 } as KeyValueSetInt
          , { key: 7, value: this.localService.languageContent.working_hours.sunday, isSelected: selectedDays.indexOf('7') > -1 } as KeyValueSetInt
        ] as KeyValueSetInt[];

        switch (this.workingRangeType) {
          case WorkingRangeType.Deliverer: {
            this.header = this.localService.languageContent.working_hours.deliverer_header;
          } break;
          case WorkingRangeType.Business: {
            this.header = this.localService.languageContent.working_hours.business_header;
          } break;
          case WorkingRangeType.PickUp: {
            this.header = this.localService.languageContent.working_hours.pickup_header;
          } break;
          case WorkingRangeType.Appoinment: {
            this.header = this.localService.languageContent.working_hours.appointment_header;
          } break;
          default: {
            this.header = this.localService.languageContent.working_hours.header;
          } break;
        }
      } else {
        this.getWeekDays();
      }
    }, this.localService.languageContent.working_hours ? 0 : 250);
  }

  onEmitValue() {
    this.selectedRange.v1 = this.isAnyTime ? '1' : '0';
    this.selectedRange.v6 = this.weekDays.filter(x => x.isSelected).map(x => x.key).join(',');
    this.onRangeUpdated.emit(this.selectedRange);
  }

  onTimeUpdate(value, isFrom) {
    if (isFrom)
      this.selectedRange.v3 = value;
    else
      this.selectedRange.v5 = value;
    this.onEmitValue();
  }
}
